/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateJobRequest,
  GetJobExecutionResponse,
  GetJobResponse,
  Result,
  UpdateJobRequest,
} from '../models/index';
import {
    CreateJobRequestFromJSON,
    CreateJobRequestToJSON,
    GetJobExecutionResponseFromJSON,
    GetJobExecutionResponseToJSON,
    GetJobResponseFromJSON,
    GetJobResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    UpdateJobRequestFromJSON,
    UpdateJobRequestToJSON,
} from '../models/index';

export interface ApiJobsGetRequest {
    xTenantID?: number;
}

export interface ApiJobsJobIdExecutionsGetRequest {
    jobId: string;
    xTenantID?: number;
}

export interface ApiJobsJobIdGetRequest {
    jobId: string;
    xTenantID?: number;
}

export interface ApiJobsJobIdPutRequest {
    jobId: string;
    updateJobRequest: UpdateJobRequest;
    xTenantID?: number;
}

export interface ApiJobsPostRequest {
    createJobRequest: CreateJobRequest;
    xTenantID?: number;
}

/**
 * 
 */
export class JobsApi extends runtime.BaseAPI {

    /**
     * Get all jobs
     * Get all jobs
     */
    async apiJobsGetRaw(requestParameters: ApiJobsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJobResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/jobs`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJobResponseFromJSON));
    }

    /**
     * Get all jobs
     * Get all jobs
     */
    async apiJobsGet(requestParameters: ApiJobsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJobResponse>> {
        const response = await this.apiJobsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get top last 25 executions for a given job
     * Get job executions
     */
    async apiJobsJobIdExecutionsGetRaw(requestParameters: ApiJobsJobIdExecutionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetJobExecutionResponse>>> {
        if (requestParameters['jobId'] == null) {
            throw new runtime.RequiredError(
                'jobId',
                'Required parameter "jobId" was null or undefined when calling apiJobsJobIdExecutionsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/jobs/{jobId}/executions`;
        urlPath = urlPath.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters['jobId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetJobExecutionResponseFromJSON));
    }

    /**
     * Get top last 25 executions for a given job
     * Get job executions
     */
    async apiJobsJobIdExecutionsGet(requestParameters: ApiJobsJobIdExecutionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetJobExecutionResponse>> {
        const response = await this.apiJobsJobIdExecutionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a job by its unique identifier
     * Get job by Id
     */
    async apiJobsJobIdGetRaw(requestParameters: ApiJobsJobIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetJobResponse>> {
        if (requestParameters['jobId'] == null) {
            throw new runtime.RequiredError(
                'jobId',
                'Required parameter "jobId" was null or undefined when calling apiJobsJobIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/jobs/{jobId}`;
        urlPath = urlPath.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters['jobId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetJobResponseFromJSON(jsonValue));
    }

    /**
     * Get a job by its unique identifier
     * Get job by Id
     */
    async apiJobsJobIdGet(requestParameters: ApiJobsJobIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetJobResponse> {
        const response = await this.apiJobsJobIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing job with the provided details.
     * Update a job
     */
    async apiJobsJobIdPutRaw(requestParameters: ApiJobsJobIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['jobId'] == null) {
            throw new runtime.RequiredError(
                'jobId',
                'Required parameter "jobId" was null or undefined when calling apiJobsJobIdPut().'
            );
        }

        if (requestParameters['updateJobRequest'] == null) {
            throw new runtime.RequiredError(
                'updateJobRequest',
                'Required parameter "updateJobRequest" was null or undefined when calling apiJobsJobIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/jobs/{jobId}`;
        urlPath = urlPath.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters['jobId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateJobRequestToJSON(requestParameters['updateJobRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates an existing job with the provided details.
     * Update a job
     */
    async apiJobsJobIdPut(requestParameters: ApiJobsJobIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiJobsJobIdPutRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a new job with the provided details.
     * Create a job
     */
    async apiJobsPostRaw(requestParameters: ApiJobsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createJobRequest'] == null) {
            throw new runtime.RequiredError(
                'createJobRequest',
                'Required parameter "createJobRequest" was null or undefined when calling apiJobsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/jobs`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateJobRequestToJSON(requestParameters['createJobRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a new job with the provided details.
     * Create a job
     */
    async apiJobsPost(requestParameters: ApiJobsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiJobsPostRaw(requestParameters, initOverrides);
    }

}
